import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import { breakpoints } from '@hover/blueprint/foundation';
import React from 'react';
import type { ReactNode } from 'react';

interface PageContainerProps extends BoxProps {
  children: ReactNode;
}

// TODO: DSYS-585 - move this to the design system and standardize variables
// This sets a standardized max width and padding for a page
// It is not on a shared parent template because we sometimes need to break out of this for full bleed
// So it is a helper to be used where appropriate
export const PageContainer = ({ children, ...props }: PageContainerProps) => (
  <Box
    marginX="auto"
    maxWidth={breakpoints.width500}
    paddingX={{ base: 500, tablet: 800 }}
    width="100%"
    {...props}
  >
    {children}
  </Box>
);
